// Handles runtime admin-driven settings persisted in Firestore and mirrored to localStorage.
import { doc, getDoc, setDoc, onSnapshot } from 'firebase/firestore';
import { auth, db } from "@/lib/firebase";

const LS_KEY = 'qq.presenter.enabled';
const SETTINGS_PATH = 'admin/settings'; // single-settings doc for the app (adjust if multi-tenant)

type AdminSettings = {
  presenterEnabled?: boolean;
  updatedBy?: string;
  updatedAt?: number; // epoch ms (client clock is fine for this lightweight flag)
};

// Read from localStorage first for instant UX
export function getPresenterEnabledFromCache(): boolean {
  const v = localStorage.getItem(LS_KEY);
  return v === 'true';
}

export function cachePresenterEnabled(v: boolean) {
  localStorage.setItem(LS_KEY, String(v));
}

export function subscribePresenterEnabled(cb: (enabled: boolean) => void) {
  const ref = doc(db, SETTINGS_PATH);
  return onSnapshot(
    ref,
    snap => {
      const data = snap.data() as AdminSettings | undefined;
      const enabled = !!data?.presenterEnabled;
      cachePresenterEnabled(enabled);
      cb(enabled);
    },
    _err => {
      // fallback to cache on error
      cb(getPresenterEnabledFromCache());
    }
  );
}

export async function setPresenterEnabled(enabled: boolean) {
  const ref = doc(db, SETTINGS_PATH);
  const uid = auth.currentUser?.uid ?? 'system';
  const payload: AdminSettings = {
    presenterEnabled: enabled,
    updatedBy: uid,
    updatedAt: Date.now(),
  };
  await setDoc(ref, payload, { merge: true });
  cachePresenterEnabled(enabled);
}

